<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <h3>REPORTE CARGAS DE PETROLEO</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-primary btn-icon" @click="cargar_datos" :disabled="!enableFiltrarButton" >
              <i class="fas fa-filter"></i> Filtrar
            </button>
            <button class="btn btn-primary btn-icon" @click="limpiar_filtros">
              <i class="fas fa-filter"></i> Limpiar Filtros
            </button>
            <button class="btn btn-success btn-icon" @click="exportar_excel">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <h5 class="mb-0">FILTROS</h5>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="table-responsive" style="height: 240px; width:auto; border: 1px solid #3c3c3c">
                          <table class="table">
                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                RANGO DE FECHAS
                              </th>
                              <td style="padding: 0.5em">
                                <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false"
                                  :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                PATENTE
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="transportes_id"
                                  :closeOnSelect="false" :options="transportes" label="patente" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                N° DE FOLIO
                              </th>
                              <td style="padding: 0.5em">
                                <input type="number" name="" id="" v-model="numero_folio" />
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col">
            <div class="tableFixHead" id="tablita" style="width: 100%">
              <table class="table table-bordered">
                <thead class="">
                  <tr>
                    <th class="fixed outlineado background-salmon-3 text-center" v-for="c in columnas" :key="c.label"
                      v-show="c.show">
                      <span class="titulo_tabla_1">{{ c.label }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in data" :key="d.id" :class="`${d.seleccionado?'background-gray':''}`" >
                    <td class="text-center" v-for="c in columnas" :key="c.label">
                      <span class="fila_tabla_1" v-if="['number'].includes(c.tipo)">
                        {{
                          devuelve_valor(d, c.path) | formatear_miles
                        }}
                      </span>
                      <span class="fila_tabla_1" v-else-if="['string'].includes(c.tipo)">
                        {{
                          devuelve_valor(d, c.path)
                        }}
                      </span>

                      <button :class="c.class" v-else-if="['button'].includes(c.tipo)" @click="click_action(c.action, d)">
                        {{ c.label_button }}
                      </button>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- MODAL -->
        <div class="modal fade" id="modaldetallecargas" data-backdrop="static" data-keyboard="false" tabindex="-1"
          role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document" style="width:95%">
            <div class="modal-content">
              <div class="modal-header" style="background-color:#172b4d;">
                <h5 class="modal-title" id="exampleModalLabel" style="color:#fff">DETALLE DE CARGAS DE PETRÓLEO</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" style="color:#fff;font-size:1.2em">&times;</span>
                </button>
              </div>

              <div class="modal-body">

                <div class="row">
                  <div class="tableFixHead" id="tablita2" style="width: 100%">
                    <table class="table table-bordered" v-if="current_item != null">
                      <thead class="">
                        <tr>
                          <th class="fixed outlineado background-salmon-3 text-center" :colspan="columnas_cargas.length"></th>
                          <th class="fixed outlineado background-salmon-3 text-center" :colspan="mps.length">RECEPCIÓN</th>
                          <th class="fixed outlineado background-salmon-3 text-center" :colspan="productos.length">DESPACHO</th>
                        
                        </tr>
                        <tr>
                          <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="col in columnas_cargas"
                            :key="col.label">
                            <span class="titulo_tabla_1">{{ col.label }}</span>
                          </th>

                          <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="mp in mps"
                            :key="`${mp.tipo}${mp.nombre}`">
                            <span class="titulo_tabla_1">{{ mp.nombre }}</span>
                          </th>

                          <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="pro in productos"
                            :key="`${pro.tipo}${pro.nombre}`">
                            <span class="titulo_tabla_1">{{ pro.nombre }}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="c in current_item.vueltas" :key="c.id" v-bind:class="{
                            'background-red-1': c.marcar_rojo == 1,
                            'background-light': c.seleccionado == 1,
                          }">
                          <td :class="['text-center',col.class?col.class:'']" v-for="col in columnas_cargas" :key="col.label" @click="c.seleccionado == 1
                              ? (c.seleccionado = 0)
                              : (c.seleccionado = 1)
                            ">
                            <span class="fila_tabla_1" v-if="['number'].includes(col.tipo)">
                              {{
                                devuelve_valor(c, col.path) | formatear_miles
                              }}
                            </span>
                            <span class="fila_tabla_1" v-else-if="['string'].includes(col.tipo)">
                              {{
                                devuelve_valor(c, col.path)
                              }}
                            </span>

                            <span class="fila_tabla_1" v-else-if="['datetime'].includes(col.tipo)">
                              {{
                                devuelve_valor(c, col.path,col.tipo)
                              }}
                            </span>
                          </td>

                          <td class="text-center" v-for="(mp,idx) in mps" :key="`${mp.nombre}${idx}`">{{devuelve_valor_detalle(c,mp,'recepcion','litros')| formatear_miles}}</td>
                          <td class="text-center" v-for="(pro,idx) in productos" :key="`${pro.nombre}${idx}`">{{devuelve_valor_detalle(c,pro,'despacho','litros')| formatear_miles}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <table class="table table-bordered" v-if="current_item != null">
                      <thead class="">
                        
                      </thead>
                      <tbody>
                        <tr style="background-color: #172b4d; color: #fff;" v-if="current_item != null">
                          <td class="text-center" style="font-size:16px;font-weight: 700;border-right: #172b4d solid 1px;">TOTAL LITROS CARGADOS</td>
                          <td colspan="3"></td>
                          <td class="text-center" style="font-size:16px;font-weight: 700;">{{current_item.total_litros_cargados | formatear_miles}}</td>
                        </tr>
                      </tbody>
                    </table>
                
                <button type="button" @click="close_modal" :class="`btn btn-primary`" data-dismiss="modal">Cerrar</button>
              </div>
            </div>
          </div>
        </div>
        <!-- MODAL -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    fechas: [],
    todos: true,
    columnas: [
      {
        show: true,
        label: "Patente",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      /*{
        show: true,
        label: "Total Cargas",
        tipo: "string",
        path: "total_cargas",
        ancho_excel: 22,
      },*/
      {
        show: true,
        label: "Total Litros Consumidos",
        tipo: "number",
        path: "total_litros",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Total Litros Cargados",
        tipo: "number",
        path: "total_litros_cargados",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Detalle Vueltas",
        tipo: "button",
        label_button: "Ver",
        class: "btn btn-success",
        action: "open_modal"
      },
    ],

    columnas_cargas: [
    {
        show: true,
        label: "Patente",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Fecha Vuelta",
        tipo: "datetime",
        path: "fecha_ingreso",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Folio",
        tipo: "string",
        path: "nro_folio",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Vuelta",
        tipo: "string",
        path: "numero_viaje",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Empresa",
        tipo: "string",
        path: "maxima_dependencia.nombre_empresa",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Sucursal",
        tipo: "string",
        path: "maxima_dependencia.nombre",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Km Teórico",
        tipo: "number",
        path: "km_teorico",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Km Real",
        tipo: "number",
        path: "km_real",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Eficiencia",
        tipo: "string",
        path: "eficiencia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tipo Kilometraje",
        tipo: "string",
        path: "tipo_kilometraje",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Rendimiento",
        tipo: "string",
        path: "rendimiento_viaje",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Litros vuelta",
        tipo: "number",
        path: "litros_viaje",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Litros Cargados",
        tipo: "number",
        path: "litros_carga",
        ancho_excel: 22,
        class:'bg-petroleo'
      },
    ],

    data: [],
    mps:[],
    productos:[],
    current_item: null,
    transportes: [],
    transportes_id: [],
    numero_folio: "",
    url_excel: null,

    // actions:[
    //     {
    //       label: "+",
    //       clase: "btn-success",
    //       evento: "showCurrentCargas",
    //     }
    //   ],

    // configuracion_modal: {
    //   titulo: "Ver Cargas Asociadas",
    //   ancho: "xl",
    //   ruta: "",
    //   tipo_ruta: "get",
    //   titulo_boton: "Ver",
    //   clase_boton: "btn-success",
    // },

    // petroleo: ,

  }),
  mounted() {
    this.data = []
    this.initialize_data()
    this.cargar_transportes();
  },
  methods: {

    click_action(action, item) {
      this.current_item = item
      if (action == 'open_modal') {
        //abrir modal
        $('#modaldetallecargas').modal({ show: true })
      }
    },

    close_modal() {
      $('#modaldetallecargas').modal({ show: false })
      this.current_item = null
    },

    limpiar_filtros() {
      this.fechas = [];
      this.transportes_id = [];
      this.numero_folio = null;
    },

    async cargar_transportes() {
      await this.axios
        .get(`${this.api}/transportes?limit=99999`, this.cabeceras_json)
        .then((res) => {
          console.log("res", res.data.data);
          this.transportes = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async cargar_datos() {
      this.data = [];
      this.url_excel = null;
      let loader = this.$loading.show({
        // Optional parameters
        canCancel: false,
        color: '#262b63',
        backgroundColor: '#ededed',
        loader: 'spinner'
      });

      let body = {};

      if (this.transportes_id.length > 0) {
        body.transportes_id = this.transportes_id;
      }

      if (this.fechas[0] != null && this.fechas[0] != undefined) {
        body.desde = this.fechas[0];
        body.hasta = this.fechas[1];
      }
      if(this.numero_folio){
        body.numero_folio = this.numero_folio
      }
      await this.axios
        .post(`${this.api}/reportes/reporte_carga_petroleo`, body, this.cabeceras_json)
        .then((res) => {
          //console.log(res.data.data);
          this.data = res.data.data;
          this.mps = res.data.mps;
          this.productos = res.data.productos;
          this.initialize_data()
          // this.total_resultado = res.data.data.total;
          this.url_excel = res.data.url;
          loader.hide();
          //console.log("url_excel", this.url_excel);
        })
        .catch((e) => {
          //console.log(e);
          loader.hide();
        });
      //}
    },

    initialize_data(){
      this.data.forEach((d,i) => {
        this.$set(this.data[i],'seleccionado',false)
      })
    },

    async exportar_excel() {
      window.open(this.url_excel, "_blank");
      /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
    },

    devuelve_valor(item, path, tipo_dato) {
      let keys = path.split(".");
      let valor = item;
      keys.forEach((k) => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }
      });
      if (tipo_dato == "datetime") {
        valor = this.$options.filters.fecha_hora(valor);
      }
      if (tipo_dato == "date") {
        valor = this.$options.filters.fecha(valor);
      }
      if (tipo_dato == "time") {
        valor = this.$options.filters.hora(valor);
      }
      return valor;
    },

    devuelve_valor_detalle(item,element,tipo,path){
      return item.detalles.find(i => i.id == element.id && i.tipo == tipo)[path];
    },

    abrirPdf(d) {
      window.open(`${this.api_public}/guias/${d.url_guia}`, "_blank");
    },

  },

  computed: {
    path() {
      return this.$router.currentRoute.path;
    },

    enableFiltrarButton() {
      this.data = [];
    return (
      this.fechas[0] ||
      this.fechas[1] ||
      this.transportes_id.length ||
      this.numero_folio
    );
  },

    ...mapState([
      "api",
      "api_public",
      "cabeceras_json",
      "token",
      "menus",
      "usuario",
    ]),
  },
};

</script>

<style>
.tableFixHead {
  overflow: auto;
  height: 600px;
  border: 1px solid rgb(212, 212, 212);
}

.fixed {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 46px;
}

.fixed-2 {
  position: sticky;
  top: 46px;
  z-index: 10;
}

.fixed-default {
  position: sticky;
  top: 0;
  z-index: 10;
}

.outlineado {
  outline: 1px solid rgb(17, 15, 15);
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 8px 16px;
}

.margen-1 {
  margin: 0em 0.5em;
}

.wrapper1,
.wrapper2 {
  width: 100%;
  border: none 0px RED;
  overflow-x: scroll;
  overflow-y: scroll;
}

.wrapper1 {
  height: 20px;
}

.wrapper2 {
  height: 600px;
}
</style>